// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"9e564519","845":"bf664047"}[chunkId] + ".chunk.js";
};